<template>
  <div class="usuario-container">
    <code>
      <el-container>
        <el-header class="usuario_header">
          Historial Actas AOM
        </el-header>
        <el-container>
          <el-header>
            <el-row>
              <el-col :span="4">
                <el-input
                  v-model="filter"
                  placeholder="Buscar por fecha corte"
                  prefix-icon="el-icon-search"
                  clearable
                  @input="handleSearch"
                ></el-input>
              </el-col>
            </el-row>
          </el-header>
          <el-main>
            <el-table :data="tableData" stripe style="width: 100%">
              <el-table-column label="Consecutivo">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{
                    scope.row.acco_consecutivo
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Fecha Corte">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{
                    scope.row.acco_fechacorte
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Fecha generación">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{
                    scope.row.acco_fechageneracion | moment('YYYY/MM/DD HH:MM')
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Usuario">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{
                    scope.row.usua_nombre
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" :label="$t('table.accion')">
                <template slot-scope="scope">
                  <el-button size="mini" @click="imprimir(scope.row)"
                    ><i class="el-icon-printer"></i
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="10"
              layout="sizes, prev, pager, next, total"
              :total="total"
            >
            </el-pagination>
          </el-main>
        </el-container>
      </el-container>
    </code>
  </div>
</template>

<script>
  import { getAllActaAom, getActaAomById } from '@/api/actas'

  export default {
    data() {
      return {
        tableData: [],
        size: 10,
        page: 1,
        total: 0,
        sort: 'acco_fechacorte',
        filter: '',
        direction: 'desc'
      }
    },
    methods: {
      imprimir(row) {
        getActaAomById(row.acco_id).then(response => {
          const contentDisposition = response.headers['name']
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', contentDisposition)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
      },
      handleSearch() {
        this.getAll()
      },
      handleSizeChange(val) {
        this.size = val
        this.getAll()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getAll()
      },
      nuevo() {
        this.$router.push({ name: 'users.create' })
      },
      getAll() {
        getAllActaAom(
          this.sort,
          this.filter,
          this.page,
          this.size,
          this.direction
        ).then(response => {
          if (response.data.data.length > 0) {
            this.total = response.data.data[0].total
            this.tableData = response.data.data
          } else {
            this.total = 0
            this.tableData = []
          }
        })
      }
    },
    mounted() {
      this.getAll()
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  .header {
    .el-header {
      .empresa_header {
        font-size: 24px;
      }
    }
  }
  td {
    padding: 4px 0;
  }
  span.el-pagination__total {
    font-size: 16px;
  }
  .search {
    width: 90vw;
    margin: auto;
    padding: auto;
  }

  .search input {
    width: 100%;
    left: 0px;
    right: 0px;
    position: relative;
    margin: auto;
    padding: auto;
  }
</style>
